import ApiService from '../api.service';

const RegisterAid = {
  create: params => ApiService.post('/api/v1/principals/register_aids', params),
};

export default RegisterAid;
